import {action, observable} from 'mobx';
import { priceTypes } from '../buyDevice'

class RenewStore {
  
  @observable renewList: priceTypes [] = []
  
  
  @action.bound async getRenewList () {
  
  }
  
}

export default RenewStore;
